export const GEO_SET_LOCALE = 'GEO_SET_LOCALE';
export const GEO_SET_CURRENCY = 'GEO_SET_CURRENCY';
